"use client";

// The default `sizes` for the core image components (ImageComponent, MediaComponent) inside a region of the page whose
// column width is known, e.g. a slider: <ImageSizesProvider value={slider_image_sizes(swiper_config)}>. An explicit
// `sizes` prop still wins; without a provider the components keep their own default.

import { createContext, useContext } from "react";

export { columns_image_sizes, slider_image_sizes } from "@core/helpers/image-sizes";

const ImageSizesContext = createContext(undefined);

export const ImageSizesProvider = ({ value, children }) => (
	<ImageSizesContext.Provider value={value || undefined}>{children}</ImageSizesContext.Provider>
);

export const useImageSizes = () => useContext(ImageSizesContext);
